var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.className,
    _vm.themeClassName
  ]},[_c(_vm.containerEl,{tag:"component",class:[
      _vm.linkClassName
    ],attrs:{"title":_vm.linkTitle,"href":_vm.linkUrl}},[_c('img-banner',{attrs:{"img-alt":_vm.imgAlt,"bg-image":_vm.bgImage,"mobile-bg-image":_vm.mobileBgImage}}),(_vm.showBox)?_c('div',{class:[
        _vm.containerTextClassName,
        _vm.containerClassName
      ]},[_c('div',{class:[
          _vm.innerContainerClassName
        ]},[(_vm.title)?_c('gc-heading',{class:[
            _vm.titleClassName,
            _vm.titleAlignClassName
          ],attrs:{"heading-size":"h2","theme":_vm.theme,"alignment":_vm.textAlign,"content":_vm.title}}):_vm._e(),(_vm.description)?_c('p',{class:[
            _vm.descriptionAlignClassName
          ]},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()],1),_c('div',{class:[
          _vm.buttonTextContainerClassName
        ]},[(_vm.buttonText)?_c('p',{class:[
            _vm.buttonTextClassName
          ]},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()])]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }